/* eslint-disable */
export default {
    questionnaire_research_questions_intro: "Voordat je met je programma van start gaat, verzoeken wij je vriendelijk onderstaande velden in te vullen.\n\nN.B: De door jou hieronder verstrekte informatie wordt alleen voor onderzoeksdoeleinden gebruikt.",
    questionnaire_research_questions_title: "Welkom",
    questionnaire_research_questions_save: "Opslaan",
    questionnaire_page_title: "Vragenlijst",
    questionnaire_go_back: "Terug",
    questionnaire_submit_questionnaire: "Opslaan en naar overzicht",
    questionnaire_next: "Volgende",
    questionnaire_back: "Terug",
    questionnaire_nl_NL: "Nederlands",
    questionnaire_en_GB: "English",
    questionnaire_finish: "Afronden",
    questionnaire_start: "Start",
    questionnaire_practice_question: "Oefenvraag",
    questionnaire_example_question: "Voorbeeldvraag",
    questionnaire_preparation_practice_questions_show_answer: "Toon antwoord",
    questionnaire_continue: "Ga verder",
    questionnaire_question: "Vraag",
    questionnaire_question_required_notification: "LET OP: De vraag is niet beantwoord. Je kunt pas naar de volgende pagina indien je de vraag beantwoord hebt.",
    questionnaire_instruction: "Instructie",
    questionnaire_route_to_overview: "Naar overzicht",
    questionnaire_could_not_retrieve_questionnaires: "Kon geen vragenlijsten ophalen. Probeer het later nog eens.",
    questionnaire_could_not_retrieve_psession: "Kon geen gegevens ophalen. Probeer het later nog eens.",
    questionnaire_finish_screen_body: "<p>Alle vragen zijn ingevuld.</p><p>Indien je iets wilt veranderen, kun je terug naar de vragenlijst. In alle andere gevallen klik je op onderstaande knop om de antwoorden in te sturen.</p><p><br></p><p><br></p>",
    questionnaire_of: "van",
    questionnaire_correct: "Correct",
    questionnaire_incorrect: "Incorrect",
    questionnaire_maximum_answers_given: "Het maximaal aantal antwoorden is al gegeven",
    questionnaire_dilemma_test_response_intro: "Geef nu aan hoe belangrijk de overwegingen waren bij de door jou gemaakte keuzes. <br />Op het volgende scherm worden de overwegingen getoond.",
    questionnaire_de_DE: "Duits",
    questionnaire_fr_FR: "Frans",
    questionnaire_no_questionnaires_available: "Er zijn op dit moment nog geen vragenlijsten beschikbaar. Deze worden in een latere fase beschikbaar gemaakt.",
    questionnaire_update_answer_error: "Er ging iets mis bij het opslaan van het antwoord, probeer het later opnieuw.",
    questionnaire_complete_questionnaire_error: "Er ging iets mis bij het invullen van de vragenlijst, probeer het later opnieuw.",
    questionnaire_fetch_questionnaire_error: "Er ging iets mis bij het ophalen van de vragenlijst, probeer het later opnieuw.",
    questionnaire_back_to_overview_cancelled: "Deze vragenlijst is geannuleerd.",
    questionnaire_back_to_overview_invalidated: "Deze vragenlijst is ongeldig verklaard.",
    questionnaire_back_to_overview_finished: "Deze vragenlijst is ingevuld.",
    questionnaire_return_to_overview_button: "Klik hier om terug te gaan naar het overzicht",
    questionnaire_back_to_overview_deadline_exceeded: "De deadline van deze vragenlijst is verstreken.",
    questionnaire_fetch_questionnaire_intro_error: "Er ging iets mis bij het ophalen van de introductie van de vragenlijst, probeer het later opnieuw.",
    questionnaire_finish_screen_finish_button: "Afronden",
    questionnaire_return_to_practice_site_button: "Keer terug naar de oefensite",
    questionnaire_practice_feedback_text_a: "Jouw uitslag voor de oefentest:",
    questionnaire_practice_feedback_text_b: "van de",
    questionnaire_practice_verify_answers_error: "Er ging iets mis bij het verifiëren van de antwoorden, probeer het later opnieuw.",
    questionnaire_dilemma_test_see_case: "Bekijk case",
    questionnaire_answer_options: "Antwoordopties",
    questionnaire_start_questionnaire_error: "Er ging iets mis bij het starten van de vragenlijst, probeer het later opnieuw.",
    questionnaire_dilemma_test_response_intro_case_dialog: "Geef nu aan hoe belangrijk de overwegingen waren bij de door jou gemaakte keuzes.",
    questionnaire_time_left: "Resterende tijd",
    questionnaire_minutes_label: "minuten",
    questionnaire_practice_feedback_question: "Vraag",
    questionnaire_practice_feedback_correct: "Correct",
    questionnaire_practice_feedback_wrong: "Fout",
    questionnaire_finish_screen_practice_explanation_flow: "U hebt alle vragen bekeken, klik op \"Voltooien\" om terug te keren naar de oefensite",
    "questionnaire_show explanations_button": "Uitleg tonen",
    questionnaire_not_answered_explanation_flow: "Deze vraag is niet beantwoord",
    questionnaire_show_explanations_button: "Uitleg tonen"
};
